<script lang="ts">
  import IconButton from "$components/+blocks/IconButton/IconButton.svelte";
  import { Check, Link } from "$components/+blocks/OVIcon";
  import { alerts } from "app/stores/alert";
  import { saveToClipboard } from "app/utils/clipboard";
  import { page } from "$app/stores";

  export let isTitle: boolean;
  export let nodeId: string;
  export let level: number;

  let icon = Link;

  function handleCopyLink(nodeId: string, isTitle: boolean = false) {
    const pageURL = $page.url;
    pageURL.hash = ""; // remove any existing url hash

    let urlToCopy = "";

    if (isTitle) {
      // if it's a title node, copy the main doc link
      urlToCopy = pageURL.href;
    } else {
      // else copy the link to the heading
      urlToCopy = `${pageURL.href}#${nodeId}`;
    }
    saveToClipboard(urlToCopy, alerts.add);
    icon = Check;
  }
</script>

{#if $page.data.isKnowledgeBase}
  <div class="animate-fade-in-short pr-2" class:pt-1={isTitle || level == 1}>
    <IconButton
      {icon}
      variant="tertiary"
      customIconSize="size-5"
      a11yLabel={`Copy link to ${isTitle ? "document" : "heading"}`}
      on:click={() => handleCopyLink(nodeId, isTitle)}
    />
  </div>
{/if}
